export const TopBarActions = {
  state: [
    "Edit Name",
    "Add Transition",
    "Remove Transitions",
    "Delete",
    "Toggle Initial State",
    "Toggle Final State",
  ],
  transition: ["Edit label", "Remove Transition"],
};
